import { HtmlLanguages, Languages } from '../interfaces/common'
import { DEFAULT_LANGUAGE } from './defaultLanguage'

export enum Locale {
  KZ = 'kk-kz',
  RU = 'ru-ru',
  UZ = 'uz-uz',
}

export const languageMap: { [index: string]: Languages } = {
  [Locale.KZ]: Languages.KZ,
  [Locale.RU]: Languages.RU,
  [Locale.UZ]: Languages.UZ,
}

export const htmlLanguageMap: { [index: string]: HtmlLanguages } = {
  [Languages.KZ]: HtmlLanguages.KZ,
  [DEFAULT_LANGUAGE]: HtmlLanguages.RU,
  [Languages.UZ]: HtmlLanguages.UZ,
}
